exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-selected[data-v-5190cc64] {\n    display: block;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    padding: 5px;\n}\n.no-selected[data-v-5190cc64]:hover {\n    background: #dfdfdf;\n}\n.selected[data-v-5190cc64] {\n    font-weight: 600;\n}\n", ""]);

// exports
